import React, { useState } from "react";

import AccessibilityConfig from "./AccessibilityConfig";
import AppTourConfig from "./AppTourConfig";
import AppUrlConfig from "./AppURLConfig";
import FeatureNameConfig from "./FeatureNameConfig";
import LanguageSwitchConfig from "./LanguageSwitchConfig";
import NotificationConfig from "./NotificationConfig";
import RoleNameConfig from "./RoleNameConfig";
import SessionConfig from "./SessionConfig";
import ThemesConfig from "./ThemesConfig";
import FeedbackFormConfig from "./FeedbackFormConfig";

const CommonConfiguration: React.FC = () => {
  const [search, setSearch] = useState("");
  const [expanded, setExpanded] = useState<string | null>(null);

  const items = [
    { key: "session", label: "Session Time" },
    { key: "tour", label: "App Tour" },
    { key: "Notifications", label: "Notifications" },
    { key: "Language Switching", label: "Language Switching" },
    { key: "Themes", label: "Themes" },
    { key: "Accessibility", label: "Accessibility" },
    { key: "App URL Config", label: "App URL Config" },
    { key: "Role Names", label: "Role Names Config" },
    { key: "Feature Names", label: "Feature Names Config" },
    { key: "Feedback Form Config", label: "Feedback Form Config" },
  ];

  const filtered = items.filter((i) => i.label.toLowerCase().includes(search.toLowerCase()));

  return (
    <div className="bg-[#f6f4ef] min-h-screen font-sans">
      <div className="p-5">
        <div className="bg-white border border-gray-200 rounded-md">
          <div className="px-5 py-4 border-b border-gray-200 flex items-center">
            <div className="flex-1">
              <h2 className="text-md font-semibold text-gray-800">Common Configuration</h2>
            </div>
          </div>

          <div className="p-5">
            <input
              type="text"
              placeholder="Search..."
              className="w-full border border-gray-200 p-2 rounded mb-4 focus:outline-none focus:ring-2 focus:ring-orange-400"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <div className="space-y-3">
              {filtered.map((item) => {
                const isExpanded = expanded === item.key;

                return (
                  <div key={item.key} className="border border-gray-200 rounded-md bg-white">
                    <div className="p-4 flex justify-between items-center">
                      <div className="text-sm font-medium text-gray-800">{item.label}</div>

                      <button
                        className="bg-[var(--color-brand)]  text-white px-3 py-1.5 rounded-md text-sm"
                        onClick={() => setExpanded(isExpanded ? null : item.key)}
                      >
                        {isExpanded ? "Close" : "Edit"}
                      </button>
                    </div>

                    {isExpanded && item.key === "session" && (
                      <div className="border-t border-gray-200 p-4 bg-[#fbfaf7]">
                        <SessionConfig />
                      </div>
                    )}

                    {isExpanded && item.key === "tour" && (
                      <div className="border-t border-gray-200 p-4 bg-[#fbfaf7]">
                        <AppTourConfig />
                      </div>
                    )}

                    {isExpanded && item.key === "Language Switching" && (
                      <div className="border-t border-gray-200 p-4 bg-[#fbfaf7]">
                        <LanguageSwitchConfig />
                      </div>
                    )}

                    {isExpanded && item.key === "Notifications" && (
                      <div className="border-t border-gray-200 p-4 bg-[#fbfaf7]">
                        <NotificationConfig />
                      </div>
                    )}
                    {isExpanded && item.key === "Themes" && (
                      <div className="border-t border-gray-200 p-4 bg-[#fbfaf7]">
                        <ThemesConfig />
                      </div>
                    )}
                    {isExpanded && item.key === "Accessibility" && (
                      <div className="border-t border-gray-200 p-4 bg-[#fbfaf7]">
                        <AccessibilityConfig />
                      </div>
                    )}
                    {isExpanded && item.key === "App URL Config" && (
                      <div className="border-t border-gray-200 p-4 bg-[#fbfaf7]">
                        <AppUrlConfig />
                      </div>
                    )}
                    {isExpanded && item.key === "Role Names" && (
                      <div className="border-t border-gray-200 p-4 bg-[#fbfaf7]">
                        <RoleNameConfig />
                      </div>
                    )}
                    {isExpanded && item.key === "Feature Names" && (
                      <div className="border-t border-gray-200 p-4 bg-[#fbfaf7]">
                        <FeatureNameConfig />
                      </div>
                    )}
                    {isExpanded && item.key === "Feedback Form Config" && (
                      <div className="border-t border-gray-200 p-4 bg-[#fbfaf7]">
                        <FeedbackFormConfig />
                      </div>
                    )}
                  </div>
                );
              })}

              {filtered.length === 0 && (
                <div className="text-sm text-gray-500 text-center py-6">No items found</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonConfiguration;
